module.exports = __webpack_public_path__ + "static/media/donald-trump.efe6ac70.jpeg";